import React from "react";
import styles from "./ReportReason.module.scss";

const ReportReason = ({ setReasonModal = () => {}, reason = "" }) => {
  const handleOverlayClick = () => {
    setReasonModal("");
  };

  const ViewSVG = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3700_13833)">
          <path
            d="M9 12H9.00667"
            stroke="#F25B5B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 6V9"
            stroke="#F25B5B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.484 1.5C11.8818 1.50008 12.2633 1.65818 12.5445 1.9395L16.0605 5.4555C16.3418 5.73674 16.4999 6.11821 16.5 6.516V11.484C16.4999 11.8818 16.3418 12.2633 16.0605 12.5445L12.5445 16.0605C12.2633 16.3418 11.8818 16.4999 11.484 16.5H6.516C6.11821 16.4999 5.73674 16.3418 5.4555 16.0605L1.9395 12.5445C1.65818 12.2633 1.50008 11.8818 1.5 11.484V6.516C1.50008 6.11821 1.65818 5.73674 1.9395 5.4555L5.4555 1.9395C5.73674 1.65818 6.11821 1.50008 6.516 1.5H11.484Z"
            stroke="#F25B5B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3700_13833">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  return (
    <section className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.reasonModal}>
        <ViewSVG />
        <p>{reason}</p>
      </div>
    </section>
  );
};

export default ReportReason;
